import { Toaster } from 'react-hot-toast';

export function Toast() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: 'var(--surface)',
          color: 'var(--text)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-md)',
          fontSize: 'var(--text-sm)',
          boxShadow: 'var(--shadow-lg)',
        },
        success: {
          iconTheme: {
            primary: 'var(--success)',
            secondary: '#ffffff',
          },
        },
        error: {
          iconTheme: {
            primary: 'var(--error)',
            secondary: '#ffffff',
          },
        },
      }}
    />
  );
}
